import React from 'react';
import { SC_Text, SC_TooltipHardware } from './TooltipHardware.styled';

export interface UHCTooltipHardwareProps {
    functionCallback?: () => void;
    onlyAvailable?: string;
    customText?: string
}

export const UHCTooltipHardware: React.FC<UHCTooltipHardwareProps> = (props: React.PropsWithChildren<UHCTooltipHardwareProps>) => {
    return (
        props.customText ?
            <SC_Text data-testid='custom-text'>{props.customText}</SC_Text>
            :
            <SC_TooltipHardware data-testid='id-div-test'>
                <SC_Text>Opções disponível a partir de:</SC_Text>
                <p className='link' onClick={() => { props.functionCallback() }}>{`${props.onlyAvailable} - Quer alterar?`}</p>
            </SC_TooltipHardware>
    );

};

